import { RANGES, useStore } from '../state/store';
import { RANGE_LABELS } from '../lib/derive';
import { Dot } from './ui';

const TITLES: Record<string, string> = {
  overview: 'Overview',
  metrics: 'Metrics',
  logs: 'Log stream',
  alerts: 'Alerts',
  server: 'Server',
};

export function TopBar() {
  const view = useStore((s) => s.view);
  const range = useStore((s) => s.range);
  const setRange = useStore((s) => s.setRange);
  const system = useStore((s) => s.system);
  const streamStatus = useStore((s) => s.streamStatus);

  const live = streamStatus === 'open';

  return (
    <div
      style={{
        minHeight: 44,
        flex: 'none',
        padding: '0 4px',
        display: 'flex',
        alignItems: 'center',
        gap: 20,
        flexWrap: 'wrap',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 800,
          fontSize: 27,
          letterSpacing: '-0.025em',
        }}
      >
        {TITLES[view]}
      </div>

      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: 9,
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: 3,
            padding: 3,
            borderRadius: 999,
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            boxShadow: 'var(--card)',
          }}
        >
          {RANGES.map((value) => {
            const on = value === range;
            return (
              <button
                key={value}
                type="button"
                className={on ? undefined : 'hoverable'}
                onClick={() => setRange(value)}
                style={{
                  padding: '5px 13px',
                  borderRadius: 999,
                  fontSize: 12.5,
                  fontWeight: on ? 600 : 400,
                  background: on ? 'var(--ink)' : 'transparent',
                  color: on ? 'var(--panel)' : 'var(--muted)',
                }}
              >
                {RANGE_LABELS[value]}
              </button>
            );
          })}
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 14px',
            borderRadius: 999,
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            boxShadow: 'var(--card)',
          }}
        >
          <Dot
            color={live ? 'var(--pos)' : 'var(--neg)'}
            ring={live ? 'var(--pos-tint)' : 'var(--neg-tint)'}
          />
          <div style={{ fontSize: 12.5, fontWeight: 600 }}>
            {system?.hostname ?? 'bridge'}
          </div>
        </div>

        <div
          title="Lifecycle actions (restart, stop, delete) are not exposed by this console."
          style={{
            padding: '8px 13px',
            borderRadius: 999,
            fontSize: 12,
            color: 'var(--faint)',
            border: '1px solid var(--line)',
          }}
        >
          Read-only
        </div>
      </div>
    </div>
  );
}
